import { render, staticRenderFns } from "./AddInvoice.vue?vue&type=template&id=23a6e3a8&scoped=true&"
import script from "./AddInvoice.vue?vue&type=script&lang=js&"
export * from "./AddInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AddInvoice.vue?vue&type=style&index=0&id=23a6e3a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a6e3a8",
  null
  
)

export default component.exports